module.exports = __webpack_public_path__ + "static/media/NATURALEZA.0b1f70a1.png";